module.exports = __webpack_public_path__ + "img/20.2c98c358.png";